import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSliderModule } from '@angular/material/slider';
import { FooterComponent } from './shared/footer/footer.component';
import { HomeComponent } from './components/home/home.component';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { RegistrarUsuarioDialogComponent } from './components/seguridad/usuarios/registrar-usuario-dialog/registrar-usuario-dialog.component';

import { ListaComponent as UsuariosListaComponent } from './components/seguridad/usuarios/lista/lista.component';
import { RegistrarComponent as UsuarioRegistrarComponent } from './components/seguridad/usuarios/registrar/registrar.component';

import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table'
import { HeaderComponent } from './shared/header/header.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common'
import {MatExpansionModule} from '@angular/material/expansion';
import {MatStepperModule} from '@angular/material/stepper';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatTreeModule} from '@angular/material/tree';
import {MatTooltipModule} from '@angular/material/tooltip';

import { SolicitudContratistaListaComponent } from './components/solicitudes/contratista/solicitud-contratista-lista/solicitud-contratista-lista.component';
import { SolicitudEngieListaComponent } from './components/solicitudes/engie/solicitud-engie-lista/solicitud-engie-lista.component';
import { SolicitudEngieRegistrarComponent } from './components/solicitudes/engie/solicitud-engie-registrar/solicitud-engie-registrar.component';
import { SolicitudContratistaCompletarComponent } from './components/solicitudes/contratista/solicitud-contratista-completar/solicitud-contratista-completar.component';
import { RegistrarEquipoDialogComponent } from './components/solicitudes/equipo/registrar-equipo-dialog/registrar-equipo-dialog.component';
import { RegistrarPersonalDialogComponent } from './components/solicitudes/personal/registrar-personal-dialog/registrar-personal-dialog.component';
import { RegistrarVehiculoDialogComponent } from './components/solicitudes/vehiculo/registrar-vehiculo-dialog/registrar-vehiculo-dialog.component';
import { RecuperarContrasenaComponent } from './components/seguridad/recuperar-contrasena/recuperar-contrasena.component';
import { RestablecerContrasenaComponent } from './components/seguridad/restablecer-contrasena/restablecer-contrasena.component';
import { CambiarContrasenaComponent } from './components/seguridad/cambiar-contrasena/cambiar-contrasena.component';
import { LoginComponent } from './components/seguridad/login/login.component';
import { SolicitudEditarComponent } from './components/solicitudes/engie/solicitud-editar/solicitud-editar.component';
import { SolicitudValidarComponent } from './components/solicitudes/validar/solicitud-validar/solicitud-validar.component';
import { ValidarPersonalDialogComponent } from './components/solicitudes/personal/validar-personal-dialog/validar-personal-dialog.component';
import { ValidarEquipoDialogComponent } from './components/solicitudes/equipo/validar-equipo-dialog/validar-equipo-dialog.component';
import { ValidarVehiculoDialogComponent } from './components/solicitudes/vehiculo/validar-vehiculo-dialog/validar-vehiculo-dialog.component';
import { AutenticacionService } from './services/seguridad/autenticacion/autenticacion.service';
import { AuthInterceptor } from './services/AuthInterceptor';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatAutocompleteModule} from '@angular/material/autocomplete';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ConfiguracionContratistaListaComponent } from './components/configuracion/contratista/configuracion-contratista-lista/configuracion-contratista-lista.component';
import { ConfiguracionContratistaRegistrarComponent } from './components/configuracion/contratista/configuracion-contratista-registrar/configuracion-contratista-registrar.component';
import { ConfiguracionContratistaEditarComponent } from './components/configuracion/contratista/configuracion-contratista-editar/configuracion-contratista-editar.component';
import { ConfiguracionSedeEditarComponent } from './components/configuracion/sede/configuracion-sede-editar/configuracion-sede-editar.component';
import { ConfiguracionSedeRegistrarComponent } from './components/configuracion/sede/configuracion-sede-registrar/configuracion-sede-registrar.component';
import { ConfiguracionSedeListarComponent } from './components/configuracion/sede/configuracion-sede-listar/configuracion-sede-listar.component';
import { ConfiguracionTipoVisitaListarComponent } from './components/configuracion/tipo-visita/configuracion-tipo-visita-listar/configuracion-tipo-visita-listar.component';
import { ConfiguracionTipoVisitaRegistrarComponent } from './components/configuracion/tipo-visita/configuracion-tipo-visita-registrar/configuracion-tipo-visita-registrar.component';
import { ConfiguracionTipoVisitaEditarComponent } from './components/configuracion/tipo-visita/configuracion-tipo-visita-editar/configuracion-tipo-visita-editar.component';
import { ConfiguracionDocumentoListarComponent } from './components/configuracion/documento/configuracion-documento-listar/configuracion-documento-listar.component';
import { ConfiguracionDocumentoRegistrarComponent } from './components/configuracion/documento/configuracion-documento-registrar/configuracion-documento-registrar.component';
import { ConfiguracionDocumentoEditarComponent } from './components/configuracion/documento/configuracion-documento-editar/configuracion-documento-editar.component';
import { AdjuntarDocumentoComponent } from './components/solicitudes/personal/documento/adjuntar-documento/adjuntar-documento.component';
import { InduccionListaComponent } from './components/induccion/induccion-lista/induccion-lista.component';
import { InduccionProgramacionListaComponent } from './components/induccion/induccion-programacion-lista/induccion-programacion-lista.component';

import { InduccionRegistroResultadosListaComponent } from './components/induccion/induccion-registro-resultados-lista/induccion-registro-resultados-lista/induccion-registro-resultados-lista.component';
import { InduccionProgramarDialogComponent } from './components/induccion/induccion-programar-dialog/induccion-programar-dialog.component';
import { AccesoComponent } from './components/accesos/acceso/acceso.component';
import { AccesoPersonalComponent } from './components/accesos/acceso-personal/acceso-personal.component';
import { AccesoCodigoDialogComponent } from './components/accesos/acceso-codigo-dialog/acceso-codigo-dialog.component';
import { AdjuntarTipoDocumentoDialogComponent } from './components/solicitudes/tipo-documento/adjuntar-tipo-documento-dialog/adjuntar-tipo-documento-dialog/adjuntar-tipo-documento-dialog.component';
import { SolicitudExtenderComponent } from './components/solicitudes/solicitud-extender/solicitud-extender.component';
import { SolicitudAmpliarPersonalComponent } from './components/solicitudes/solicitud-ampliar-personal/solicitud-ampliar-personal.component';
import { SolicitudAprobacionComponent } from './components/solicitudes/solicitud-aprobacion/solicitud-aprobacion.component';
import { SolicitudMasterComponent } from './components/solicitudes/solicitud-master/solicitud-master.component';
import { SolicitudMasterReadonlyComponent } from './components/solicitudes/solicitud-master-readonly/solicitud-master-readonly/solicitud-master-readonly.component';
import { PersonalReadonlyDialogComponent } from './components/solicitudes/personal/personal-readonly-dialog/personal-readonly-dialog.component';
import { EquipoReadonlyDialogComponent } from './components/solicitudes/equipo/equipo-readonly-dialog/equipo-readonly-dialog.component';
import { VehiculoReadonlyDialogComponent } from './components/solicitudes/vehiculo/vehiculo-readonly-dialog/vehiculo-readonly-dialog.component';
import { PersonaFormComponent } from './components/solicitudes/personal/persona-form/persona-form.component';
import { EquipoFormComponent } from './components/solicitudes/equipo/equipo-form/equipo-form.component';
import { VehiculoFormComponent } from './components/solicitudes/vehiculo/vehiculo-form/vehiculo-form.component';
import { SolicitudesBandejaSupervisorComponent } from './components/solicitudes/solicitudes-bandeja-supervisor/solicitudes-bandeja-supervisor.component';
import { SolicitudesBandejaRevisorComponent } from './components/solicitudes/solicitudes-bandeja-revisor/solicitudes-bandeja-revisor.component';
import { SolicitudDerivarDialogComponent } from './components/solicitudes/dialogs/solicitud-derivar-dialog/solicitud-derivar-dialog.component';
import { SolicitudRevisorValidarComponent } from './components/solicitudes/solicitud-revisor-validar/solicitud-revisor-validar.component';
import { InduccionFiltrosBusquedaComponent } from './components/induccion/induccion-filtros-busqueda/induccion-filtros-busqueda.component';
import { ValidarVigenciaComponent } from './components/accesos/validar-vigencia/validar-vigencia.component';
import { getSpanishPaginatorIntl } from './shared/spanish-paginator-intl';
import { VigilanteAccesosListaComponent } from './components/vigilante/vigilante-accesos-lista/vigilante-accesos-lista.component';
import { DeshabilitarAccesosPersonalComponent } from './components/accesos/deshabilitar-accesos-personal/deshabilitar-accesos-personal.component';
import { DeshabilitarAccesosPersonalDialogComponent } from './components/accesos/deshabilitar-accesos-personal-dialog/deshabilitar-accesos-personal-dialog.component';
import { AccesosPorVencerListaComponent } from './components/accesos/accesos-por-vencer-lista/accesos-por-vencer-lista.component';
import { InduccionReprogramarDialogComponent } from './components/induccion/induccion-reprogramar-dialog/induccion-reprogramar-dialog/induccion-reprogramar-dialog.component';
import { SolicitudPersonaRenovarDocumentoDialogComponent } from './components/solicitudes/dialogs/solicitud-persona-renovar-documento-dialog/solicitud-persona-renovar-documento-dialog.component';
import { SolicitudValidarRenovacionDocumentosListaComponent } from './components/solicitudes/solicitud-validar-renovacion-documentos-lista/solicitud-validar-renovacion-documentos-lista.component';
import { SolicitudContratistaDocumentoPorVencerListaComponent } from './components/solicitudes/contratista/solicitud-contratista-documento-por-vencer-lista/solicitud-contratista-documento-por-vencer-lista.component';
import { SolicitudPendienteAccesoListaComponent } from './components/solicitudes/solicitud-pendiente-acceso-lista/solicitud-pendiente-acceso-lista.component';
import { AccesoPersonalContratistaListaComponent } from './components/accesos/acceso-personal-contratista-lista/acceso-personal-contratista-lista.component';
import { AccesosFiltrosBusquedaComponent } from './components/accesos/accesos-filtros-busqueda/accesos-filtros-busqueda.component';
import { LoaderComponent } from './shared/loader/loader.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SpinnerInterceptor } from './services/SpinnerInterceptor';
import { ConfirmDialogComponent } from './shared/confirm-dialog/confirm-dialog.component';
import { ErrorInterceptor } from './_helpers/error.interceptor';
import { MaestroDocumentoRegistrarComponent } from './components/configuracion/maestro-documento/maestro-documento-registrar/maestro-documento-registrar.component';
import { MaestroDocumentoEditarComponent } from './components/configuracion/maestro-documento/maestro-documento-editar/maestro-documento-editar.component';
import { MaestroDocumentoListarComponent } from './components/configuracion/maestro-documento/maestro-documento-listar/maestro-documento-listar.component';
import { AccesoFiltrosBusquedaComponent } from './components/accesos/acceso-filtros-busqueda/acceso-filtros-busqueda.component';
import { AlertDialogComponent } from './shared/alert-dialog/alert-dialog.component';
import { SolicitudDetalleComponent } from './components/solicitudes/solicitud-detalle/solicitud-detalle.component';
import { LogTableComponent } from './components/shared/log-table/log-table.component';
import { LogDialogComponent } from './components/shared/log-dialog/log-dialog.component';
import { LogDialogAnchorComponent } from './components/shared/log-dialog-anchor/log-dialog-anchor.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CallbackComponent } from './components/callback/callback.component';
import { AccesoDenegadoComponent } from './components/acceso-denegado/acceso-denegado.component';
import { InduccionPersonasListaComponent } from './components/induccion/induccion-personas-lista/induccion-personas-lista.component';
import { InduccionResultadosDialogComponent } from './components/induccion/induccion-resultados-dialog/induccion-resultados-dialog.component';
import { SolicitudContratistaRegistrarComponent } from './components/solicitudes/contratista/solicitud-contratista-registrar/solicitud-contratista-registrar.component';
import { ConfiguracionTipoVisitaDefaultDialogComponent } from './components/configuracion/tipo-visita/configuracion-tipo-visita-default-dialog/configuracion-tipo-visita-default-dialog.component';
import { SolicitudMasterProgressComponent } from './components/solicitudes/solicitud-master-progress/solicitud-master-progress.component';
import { ListanegraListaComponent } from './components/listanegra/listanegra-lista/listanegra-lista.component';
import { ListanegraRegistrarComponent } from './components/listanegra/listanegra-registrar/listanegra-registrar.component';
import { SsoCalendarioListarComponent } from './components/informacionsso/calendario/sso-calendario-listar/sso-calendario-listar.component';
import { SsoCalendarioRegistrarComponent } from './components/informacionsso/calendario/sso-calendario-registrar/sso-calendario-registrar.component';
import { SsoContratistaListarComponent } from './components/informacionsso/contratista/sso-contratista-listar/sso-contratista-listar.component';
import { SsoEngieListarComponent } from './components/informacionsso/engie/sso-engie-listar/sso-engie-listar.component';
import { PasstSeguimientoListarComponent } from './components/passt/passt-seguimiento-listar/passt-seguimiento-listar.component';
import { PasstPlanificacionCargaComponent } from './components/passt/passt-planificacion-carga/passt-planificacion-carga.component';
import { SsoSolicitarAmpliacionComponent } from './components/informacionsso/ampliacion/sso-solicitar-ampliacion/sso-solicitar-ampliacion.component';
import { SsoEngieAccidentabilidadDialogComponent } from './components/informacionsso/engie/sso-engie-accidentabilidad-dialog/sso-engie-accidentabilidad-dialog.component';
import { SsoSolicitarNuevaempresaDialogComponent } from './components/informacionsso/ampliacion/sso-solicitar-nuevaempresa-dialog/sso-solicitar-nuevaempresa-dialog.component';
import { SsoAmpliacionBandejaAprobacionComponent } from './components/informacionsso/ampliacion/sso-ampliacion-bandeja-aprobacion/sso-ampliacion-bandeja-aprobacion.component';
import { SsoAmpliacionAprobacionDialogComponent } from './components/informacionsso/ampliacion/sso-ampliacion-aprobacion-dialog/sso-ampliacion-aprobacion-dialog.component';
import { HiposSeguimientoListarComponent } from './components/hipos/hipos-seguimiento-listar/hipos-seguimiento-listar.component';
import { HiposSeguimientoRegistrarComponent } from './components/hipos/hipos-seguimiento-registrar/hipos-seguimiento-registrar.component';
import { ConfiguracionProyectoListarComponent } from './components/configuracion/proyecto/configuracion-proyecto-listar/configuracion-proyecto-listar.component';
import { ConfiguracionProyectoRegistrarComponent } from './components/configuracion/proyecto/configuracion-proyecto-registrar/configuracion-proyecto-registrar.component';
import { ConfiguracionProyectoEditarComponent } from './components/configuracion/proyecto/configuracion-proyecto-editar/configuracion-proyecto-editar.component';
import { ConfiguracionGbuListarComponent } from './components/configuracion/gbu/configuracion-gbu-listar/configuracion-gbu-listar.component';
import { ConfiguracionGbuRegistrarComponent } from './components/configuracion/gbu/configuracion-gbu-registrar/configuracion-gbu-registrar.component';
import { ConfiguracionGbuEditarComponent } from './components/configuracion/gbu/configuracion-gbu-editar/configuracion-gbu-editar.component';
import { ConfiguracionTipoReglaListarComponent } from './components/configuracion/tipo-regla/configuracion-tipo-regla-listar/configuracion-tipo-regla-listar.component';
import { ConfiguracionTipoReglaRegistrarComponent } from './components/configuracion/tipo-regla/configuracion-tipo-regla-registrar/configuracion-tipo-regla-registrar.component';
import { ConfiguracionTipoReglaEditarComponent } from './components/configuracion/tipo-regla/configuracion-tipo-regla-editar/configuracion-tipo-regla-editar.component';
import { ConfiguracionTipoEmpleadoListarComponent } from './components/configuracion/tipo-empleado/configuracion-tipo-empleado-listar/configuracion-tipo-empleado-listar.component';
import { ConfiguracionTipoEmpleadoRegistrarComponent } from './components/configuracion/tipo-empleado/configuracion-tipo-empleado-registrar/configuracion-tipo-empleado-registrar.component';
import { ConfiguracionTipoEmpleadoEditarComponent } from './components/configuracion/tipo-empleado/configuracion-tipo-empleado-editar/configuracion-tipo-empleado-editar.component';
import { ConfiguracionCategoriaHipoListarComponent } from './components/configuracion/categoria-hipo/configuracion-categoria-hipo-listar/configuracion-categoria-hipo-listar.component';
import { ConfiguracionCategoriaHipoRegistrarComponent } from './components/configuracion/categoria-hipo/configuracion-categoria-hipo-registrar/configuracion-categoria-hipo-registrar.component';
import { ConfiguracionCategoriaHipoEditarComponent } from './components/configuracion/categoria-hipo/configuracion-categoria-hipo-editar/configuracion-categoria-hipo-editar.component';
import { ConfiguracionActoCondicionListarComponent } from './components/configuracion/acto-condicion/configuracion-acto-condicion-listar/configuracion-acto-condicion-listar.component';
import { ConfiguracionActoCondicionRegistrarComponent } from './components/configuracion/acto-condicion/configuracion-acto-condicion-registrar/configuracion-acto-condicion-registrar.component';
import { ConfiguracionActoCondicionEditarComponent } from './components/configuracion/acto-condicion/configuracion-acto-condicion-editar/configuracion-acto-condicion-editar.component';
import { PasstPlanificacionRegistrarDialogComponent } from './components/passt/passt-planificacion-registrar-dialog/passt-planificacion-registrar-dialog.component';
import { SsoAmpliacionHistorialSolicitudesComponent } from './components/informacionsso/ampliacion/sso-ampliacion-historial-solicitudes/sso-ampliacion-historial-solicitudes.component';
import { HiposSeguimientoEditarComponent } from './components/hipos/hipos-seguimiento-editar/hipos-seguimiento-editar.component';
import { HiposAccionRegistrarDialogComponent } from './components/hipos/hipos-accion-registrar-dialog/hipos-accion-registrar-dialog.component';
import { ConfiguracionTipoAccidenteListarComponent } from './components/configuracion/tipo-accidente/configuracion-tipo-accidente-listar/configuracion-tipo-accidente-listar.component';
import { ConfiguracionTipoAccidenteRegistrarComponent } from './components/configuracion/tipo-accidente/configuracion-tipo-accidente-registrar/configuracion-tipo-accidente-registrar.component';
import { ConfiguracionTipoAccidenteEditarComponent } from './components/configuracion/tipo-accidente/configuracion-tipo-accidente-editar/configuracion-tipo-accidente-editar.component';
import { PasstActividadReprogramarDialogComponent } from './components/passt/passt-actividad-reprogramar-dialog/passt-actividad-reprogramar-dialog.component';
import { PasstActividadCancelarDialogComponent } from './components/passt/passt-actividad-cancelar-dialog/passt-actividad-cancelar-dialog.component';
import { PasstActividadEliminarDialogComponent } from './components/passt/passt-actividad-eliminar-dialog/passt-actividad-eliminar-dialog.component';
import { PasstActividadSolicitarEdicionDialogComponent } from './components/passt/passt-actividad-solicitar-edicion-dialog/passt-actividad-solicitar-edicion-dialog.component';
import { PasstActividadComentariosDialogComponent } from './components/passt/passt-actividad-comentarios-dialog/passt-actividad-comentarios-dialog.component';
import { TwoDigitDecimaNumberDirective } from './_helpers/TwoDigitDecimaNumberDirective';
import { PasstSolicitarProgramacionEdicionDialogComponent } from './components/passt/passt-solicitar-programacion-edicion-dialog/passt-solicitar-programacion-edicion-dialog.component';
import { PasstRotuloEditarComponent } from './components/passt/passt-rotulo-editar/passt-rotulo-editar.component';
import { PasstObjetivoRegistrarDialogComponent } from './components/passt/passt-objetivo-registrar-dialog/passt-objetivo-registrar-dialog.component';
import { OnlyNumberDirective } from './_helpers/OnlyNumberDirective';
import { OneDigitDecimaNumberDirective } from './_helpers/OneDigitDecimaNumberDirective';
import { SolicitudesBandejaAdminComponent } from './components/solicitudes/solicitudes-bandeja-admin/solicitudes-bandeja-admin.component';
import { SolicitudMasterEditHeaderComponent } from './components/solicitudes/solicitud-master-edit-header/solicitud-master-edit-header.component';
import { ParametrosConfiguracionListarComponent } from './components/configuracion/parametros/parametros-configuracion-listar/parametros-configuracion-listar.component';
import { ParametrosConfiguracionEditarComponent } from './components/configuracion/parametros/parametros-configuracion-editar/parametros-configuracion-editar.component';
import { SolicitudPonerStandByDialogComponent } from './components/solicitudes/stand-by/solicitud-poner-stand-by-dialog/solicitud-poner-stand-by-dialog.component';
import { SolicitudQuitarStandByDialogComponent } from './components/solicitudes/stand-by/solicitud-quitar-stand-by-dialog/solicitud-quitar-stand-by-dialog.component';
import { ReestablecerAccesosPersonalDialogComponent } from './components/accesos/reestablecer-accesos-personal-dialog/reestablecer-accesos-personal-dialog.component';
import { VisorPdfDialogComponent } from './components/shared/visor-pdf-dialog/visor-pdf-dialog.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SolicitudPendienteAccesoDetalleDialogComponent } from './components/solicitudes/solicitud-pendiente-acceso-detalle-dialog/solicitud-pendiente-acceso-detalle-dialog.component';
import { SolicitudAdicionarInfoComponent } from './components/solicitudes/solicitud-adicionar-info/solicitud-adicionar-info.component';
import { ConfiguracionCompaniaListaComponent } from './components/configuracion/compania/configuracion-compania-lista/configuracion-compania-lista.component';
import { ConfiguracionCompaniaRegistrarComponent } from './components/configuracion/compania/configuracion-compania-registrar/configuracion-compania-registrar.component';
import { ConfiguracionCompaniaEditarComponent } from './components/configuracion/compania/configuracion-compania-editar/configuracion-compania-editar.component';

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HomeComponent,
    UsuariosListaComponent,
    UsuarioRegistrarComponent,
    HeaderComponent,
    RegistrarUsuarioDialogComponent,
    SolicitudContratistaListaComponent,
    SolicitudEngieListaComponent,
    SolicitudEngieRegistrarComponent,
    SolicitudContratistaCompletarComponent,
    RegistrarEquipoDialogComponent,
    RegistrarPersonalDialogComponent,
    RegistrarVehiculoDialogComponent,
    RecuperarContrasenaComponent,
    RestablecerContrasenaComponent,
    CambiarContrasenaComponent,
    LoginComponent,
    SolicitudEditarComponent,
    SolicitudValidarComponent,
    ValidarPersonalDialogComponent,
    ValidarEquipoDialogComponent,
    ValidarVehiculoDialogComponent,
    ConfiguracionContratistaListaComponent,
    ConfiguracionContratistaRegistrarComponent,
    ConfiguracionContratistaEditarComponent,
    ConfiguracionSedeEditarComponent,
    ConfiguracionSedeRegistrarComponent,
    ConfiguracionSedeListarComponent,
    ConfiguracionTipoVisitaListarComponent,
    ConfiguracionTipoVisitaRegistrarComponent,
    ConfiguracionTipoVisitaEditarComponent,
    ConfiguracionDocumentoListarComponent,
    ConfiguracionDocumentoRegistrarComponent,
    ConfiguracionDocumentoEditarComponent,
    AdjuntarDocumentoComponent,
    InduccionListaComponent,
    InduccionProgramacionListaComponent,
    InduccionRegistroResultadosListaComponent,
    InduccionProgramarDialogComponent,
    AccesoComponent,
    AccesoPersonalComponent,
    AccesoCodigoDialogComponent,
    AccesoPersonalContratistaListaComponent,
    AdjuntarTipoDocumentoDialogComponent,
    SolicitudExtenderComponent,
    SolicitudAmpliarPersonalComponent,
    SolicitudAprobacionComponent,
    SolicitudMasterComponent,
    SolicitudMasterReadonlyComponent,
    PersonalReadonlyDialogComponent,
    EquipoReadonlyDialogComponent,
    VehiculoReadonlyDialogComponent,
    PersonaFormComponent,
    EquipoFormComponent,
    VehiculoFormComponent,
    SolicitudesBandejaSupervisorComponent,
    SolicitudesBandejaRevisorComponent,
    SolicitudDerivarDialogComponent,
    SolicitudRevisorValidarComponent,
    InduccionFiltrosBusquedaComponent,
    ValidarVigenciaComponent,
    VigilanteAccesosListaComponent,
    DeshabilitarAccesosPersonalComponent,
    DeshabilitarAccesosPersonalDialogComponent,
    AccesosPorVencerListaComponent,
    InduccionReprogramarDialogComponent,
    SolicitudContratistaDocumentoPorVencerListaComponent,
    SolicitudPersonaRenovarDocumentoDialogComponent,
    SolicitudValidarRenovacionDocumentosListaComponent,
    SolicitudPendienteAccesoListaComponent,
    AccesosFiltrosBusquedaComponent,
    LoaderComponent,
    ConfirmDialogComponent,
    MaestroDocumentoRegistrarComponent,
    MaestroDocumentoEditarComponent,
    MaestroDocumentoListarComponent,
    AccesoFiltrosBusquedaComponent,
    AlertDialogComponent,
    SolicitudDetalleComponent,
    LogTableComponent,
    LogDialogComponent,
    LogDialogAnchorComponent,
    CallbackComponent,
    AccesoDenegadoComponent,
    InduccionPersonasListaComponent,
    InduccionResultadosDialogComponent,
    SolicitudContratistaRegistrarComponent,
    ConfiguracionTipoVisitaDefaultDialogComponent,
    SolicitudMasterProgressComponent,
    ListanegraListaComponent,
    ListanegraRegistrarComponent,
    SsoCalendarioListarComponent,
    SsoCalendarioRegistrarComponent,
    SsoContratistaListarComponent,
    SsoEngieListarComponent,
    PasstSeguimientoListarComponent,
    PasstPlanificacionCargaComponent,
    SsoSolicitarAmpliacionComponent,
    SsoEngieAccidentabilidadDialogComponent,
    SsoSolicitarNuevaempresaDialogComponent,
    SsoAmpliacionBandejaAprobacionComponent,
    SsoAmpliacionAprobacionDialogComponent,
    HiposSeguimientoListarComponent,
    HiposSeguimientoRegistrarComponent,
    ConfiguracionProyectoListarComponent,
    ConfiguracionProyectoRegistrarComponent,
    ConfiguracionProyectoEditarComponent,
    ConfiguracionGbuListarComponent,
    ConfiguracionGbuRegistrarComponent,
    ConfiguracionGbuEditarComponent,
    ConfiguracionTipoReglaListarComponent,
    ConfiguracionTipoReglaRegistrarComponent,
    ConfiguracionTipoReglaEditarComponent,
    ConfiguracionTipoEmpleadoListarComponent,
    ConfiguracionTipoEmpleadoRegistrarComponent,
    ConfiguracionTipoEmpleadoEditarComponent,
    ConfiguracionCategoriaHipoListarComponent,
    ConfiguracionCategoriaHipoRegistrarComponent,
    ConfiguracionCategoriaHipoEditarComponent,
    ConfiguracionActoCondicionListarComponent,
    ConfiguracionActoCondicionRegistrarComponent,
    ConfiguracionActoCondicionEditarComponent,
    PasstPlanificacionRegistrarDialogComponent,
    SsoAmpliacionHistorialSolicitudesComponent,
    HiposSeguimientoEditarComponent,
    HiposAccionRegistrarDialogComponent,
    ConfiguracionTipoAccidenteListarComponent,
    ConfiguracionTipoAccidenteRegistrarComponent,
    ConfiguracionTipoAccidenteEditarComponent,
    PasstActividadReprogramarDialogComponent,
    PasstActividadCancelarDialogComponent,
    PasstActividadEliminarDialogComponent,
    PasstActividadSolicitarEdicionDialogComponent,
    PasstActividadComentariosDialogComponent,
    TwoDigitDecimaNumberDirective,
    PasstSolicitarProgramacionEdicionDialogComponent,
    PasstRotuloEditarComponent,
    PasstObjetivoRegistrarDialogComponent,
    OnlyNumberDirective,
    OneDigitDecimaNumberDirective,
    SolicitudesBandejaAdminComponent,
    SolicitudMasterEditHeaderComponent,
    ParametrosConfiguracionListarComponent,
    ParametrosConfiguracionEditarComponent,
    SolicitudPonerStandByDialogComponent,
    SolicitudQuitarStandByDialogComponent,
    ReestablecerAccesosPersonalDialogComponent,
    VisorPdfDialogComponent,
    SolicitudPendienteAccesoDetalleDialogComponent,
    SolicitudAdicionarInfoComponent,
    ConfiguracionCompaniaListaComponent,
    ConfiguracionCompaniaRegistrarComponent,
    ConfiguracionCompaniaEditarComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatSliderModule,
    LayoutModule,
    MatAutocompleteModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatCheckboxModule,
    MatIconModule,
    MatListModule,
    MatTableModule,
    MatPaginatorModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDialogModule,
    MatDatepickerModule,    
    MatSlideToggleModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    NgxMatSelectSearchModule,
    MatExpansionModule,
    MatStepperModule,
    MatProgressBarModule,
    MatTreeModule,
    MatTooltipModule,
    PdfViewerModule,
    MatMenuModule
  ],
  providers: [
    AutenticacionService, {
      provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: MatPaginatorIntl, useValue: getSpanishPaginatorIntl() },
    { provide: MAT_DATE_LOCALE, useValue: 'es-PE' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true,
    },
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
